import { AssemblyPill } from '@/components/AssetsPage/AssemblyPill';
import { RootAssemblyPill } from '@/components/AssetsPage/RootAssemblyPill';
import { Ellipsis } from '@/components/Ellipsis';
import { MissingDependencyIcon } from '@/components/MissingDependencyIcon/MissingDependencyIcon';
import { Box, Tooltip } from '@mui/material';
import { useState } from 'react';

export const AssetNameWithExtension = ({
  name,
  path,
  extension,
  showAssemblyPill,
  isRootAssembly,
  isMissingDependencies,
}: {
  name: string;
  path: string;
  extension: string;
  showAssemblyPill?: boolean;
  isRootAssembly?: boolean;
  isMissingDependencies?: boolean;
}) => {
  const [isNameTruncated, setIsNameTruncated] = useState(false);

  return (
    <>
      <Tooltip title={isNameTruncated ? path : ''}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            minWidth: 0,
          }}
        >
          <Ellipsis
            text={name}
            tooltipProps={{ hideTooltip: true }}
            onTruncationChange={setIsNameTruncated}
            sx={{ display: 'block', flex: '1 1 auto', minWidth: 0 }}
          />
          <Box component='span' sx={{ flexShrink: 0 }}>
            {extension}
          </Box>
        </Box>
      </Tooltip>
      {showAssemblyPill && isRootAssembly && <RootAssemblyPill>root</RootAssemblyPill>}
      {showAssemblyPill && <AssemblyPill>asm</AssemblyPill>}
      {isMissingDependencies && <MissingDependencyIcon />}
    </>
  );
};
